module.exports = __webpack_public_path__ + "static/media/logo.12a6659f.svg";